// Credit packs — must match backend/src/billing.js PACKS exactly (id, prices
// per currency, scan count). Volume-discounted: bigger packs cost less per
// scan because they deposit more wallet balance per dollar/euro/pound, not
// because the per-scan debit rate changes (see backend/src/wallet.js
// MILLICREDITS_PER_SCAN).
//
// Each pack prices in usd/eur/gbp independently rather than converting the
// USD price live — same approach anyainow's buy page takes, so the number
// shown is a clean, stable local price instead of odd cents from a spot FX
// rate, and doesn't drift between page load and checkout.
export const CURRENCIES = [
  { code: "usd", symbol: "$", label: "$ USD" },
  { code: "eur", symbol: "€", label: "€ EUR" },
  { code: "gbp", symbol: "£", label: "£ GBP" },
];

export const PACKS = [
  {
    id: "starter",
    label: "Starter",
    scans: 300,
    prices: { usd: 900, eur: 800, gbp: 700 },
  },
  {
    id: "growth",
    label: "Growth",
    scans: 700,
    prices: { usd: 1900, eur: 1700, gbp: 1500 },
  },
  {
    id: "business",
    label: "Business",
    scans: 1600,
    prices: { usd: 3900, eur: 3500, gbp: 3100 },
    badge: "Most popular",
  },
  {
    id: "pro",
    label: "Pro",
    scans: 3600,
    prices: { usd: 7900, eur: 7100, gbp: 6200 },
  },
];

// Reads the browser locale to guess a sensible default currency — the buyer
// can always switch with the toggle. Mirrors anyainow's detectCurrency().
export function detectCurrency() {
  const lang =
    (typeof navigator !== "undefined" && navigator.language) || "en-US";
  const [langCode, country] = lang.split("-");

  if (country === "GB" || lang === "en-GB") return "gbp";

  const eurCountries = new Set([
    "AT", "BE", "CY", "EE", "FI", "FR", "DE", "GR", "IE", "IT",
    "LV", "LT", "LU", "MT", "NL", "PT", "SK", "SI", "ES",
  ]);
  const eurLangs = new Set([
    "de", "fr", "nl", "it", "el", "fi", "et", "lv", "lt", "mt", "sk", "sl",
  ]);

  if (country && eurCountries.has(country)) return "eur";
  if (!country && eurLangs.has(langCode)) return "eur";
  if (langCode === "es" && (!country || country === "ES")) return "eur";
  if (langCode === "pt" && (!country || country === "PT")) return "eur";

  return "usd";
}

export function formatPrice(pack, currency) {
  const cents = pack.prices[currency];
  const symbol = CURRENCIES.find((c) => c.code === currency)?.symbol || "";
  return `${symbol}${(cents / 100).toFixed(cents % 100 === 0 ? 0 : 2)}`;
}

export function formatPerScan(pack, currency) {
  const cents = pack.prices[currency];
  const symbol = CURRENCIES.find((c) => c.code === currency)?.symbol || "";
  return `${symbol}${(cents / 100 / pack.scans).toFixed(3)}`;
}
